import { render, staticRenderFns } from "./lambang.vue?vue&type=template&id=b3953106&"
import script from "./lambang.vue?vue&type=script&lang=js&"
export * from "./lambang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports